import { render, staticRenderFns } from "./uploadTip-editor.vue?vue&type=template&id=e50d47c6&scoped=true"
import script from "./uploadTip-editor.vue?vue&type=script&lang=js"
export * from "./uploadTip-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50d47c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e50d47c6')) {
      api.createRecord('e50d47c6', component.options)
    } else {
      api.reload('e50d47c6', component.options)
    }
    module.hot.accept("./uploadTip-editor.vue?vue&type=template&id=e50d47c6&scoped=true", function () {
      api.rerender('e50d47c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/uploadTip-editor.vue"
export default component.exports